import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/element/header-section/HeaderSection";
import Contact from "./Contact/Contact";
import t from "../helpers/t9n";

const ContactPage = () => {
  let { lang } = useParams();
  
  return (
    <>
      <Header heading={t("menu.contact")} hasImage={true} isRed={true} />
      <Contact lang={lang} />
    </>
  )
}

export default ContactPage;
